import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

const BoomerangIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path d='M3.1 4.3c-.7-.5-1.5.3-1.1 1l7.1 12.3c.8 1.4 2.6 2 4.1 1.3l8.4-4c.8-.4.4-1.6-.5-1.5l-7.5 1.1c-.7.1-1.4-.2-1.8-.8L3.1 4.3Z' />
  </SvgIcon>
);

export default BoomerangIcon;
